var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.071,
    height: 31.07,
    viewBox: "0 0 31.071 31.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin-in",
    d: "M6.955,31.08H.513V10.336H6.955ZM3.731,7.506A3.748,3.748,0,1,1,7.461,3.741,3.762,3.762,0,0,1,3.731,7.506ZM31.064,31.08H24.636v-10.1c0-2.407-.049-5.493-3.349-5.493-3.349,0-3.862,2.615-3.862,5.319V31.08H10.99V10.336h6.178v2.83h.09a6.769,6.769,0,0,1,6.095-3.35c6.519,0,7.718,4.293,7.718,9.869V31.08Z",
    transform: "translate(0 -0.01)",
    fill: "#00c1d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIn);
export default __webpack_public_path__ + "static/media/linkedin-in.844e571c57d48230843dcff450d480cb.svg";
export { ForwardRef as ReactComponent };